export const AUTH_TOKEN = 'token';
export const AUTH_TOKEN_DURATION = 'token-duration';

export const resetAuthStorage = (): void => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(AUTH_TOKEN_DURATION);
};

export const updateAuthTokenStorage = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN, token);
};

export const updateAuthTokenDurationStorage = (
  duration: string | number,
): void => {
  localStorage.setItem(AUTH_TOKEN_DURATION, String(duration));
};

export const getAuthTokenStorage = (): string => {
  return localStorage.getItem(AUTH_TOKEN) || '';
};
export const getAuthTokenDurationStorage = (): string => {
  return localStorage.getItem(AUTH_TOKEN_DURATION) || '';
};
